import { render } from "./addCustomers.vue?vue&type=template&id=8820e71e&scoped=true"
import script from "./addCustomers.vue?vue&type=script&lang=js"
export * from "./addCustomers.vue?vue&type=script&lang=js"

import "./addCustomers.vue?vue&type=style&index=0&id=8820e71e&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8820e71e"]])

export default __exports__